{
  "schemaVersion": 2,
  "target": {
    "projectId": "soko-grid",
    "frontendProjectId": "soko-grid",
    "storageBucket": "soko-grid.firebasestorage.app",
    "functionsRegion": "africa-south1"
  },
  "businessProfileDatasetSha256": "4f7a47c6101f0d37cf832232f3aa8213cbf16a545d177bede82003d5b7a8ce3c",
  "searchLandingDatasetSha256": "c36ff173abe92f0fe4d6b52dcb08957b4038a0baa5e5ebd0c238adcd3e5f37e4",
  "businessProfileRoutes": [
    "/p/babbles-inflatable",
    "/p/kluger-properties",
    "/p/sample-business"
  ],
  "searchLandingRoutes": [
    "/s/bakeries-and-snacks-shops-in-cbd",
    "/s/bouncing-castle-and-popcorn-planet-in-kikuyu",
    "/s/bouncing-castle-and-popcorn-planet-in-sigona",
    "/s/land-and-plots-in-kikuyu",
    "/s/land-and-plots-in-sigona"
  ]
}
